import { PropsWithChildren } from 'react'

import { createGenericContext } from '@/Shared/ui/createGenericContext'
import { TpvsRepository } from '@/Store/domain'
import { IUseTpvController, useTpvController } from '@/Store/ui/hooks'

type Context = {
  repository: TpvsRepository
} & IUseTpvController

type Props = PropsWithChildren & {
  repository: TpvsRepository
  id: number
}

const [useTpv, StateContextProvider] = createGenericContext<Context>()

const TpvProvider = ({ repository, id, children }: Props): JSX.Element => {
  const controller = useTpvController(repository, id)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { TpvProvider, useTpv }
